/**
 * Generates a unique reference number for errors
 * Format: ERR-YYYYMMDD-RANDOM6CHARS
 */
export const generateErrorReferenceNumber = (): string => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  
  // Generate a random 6-character alphanumeric string
  const randomChars = Math.random().toString(36).substring(2, 8).toUpperCase();
  
  return `ERR-${yyyy}${mm}${dd}-${randomChars}`;
};